import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle, Circle, CircleHalf, Headphones } from "@phosphor-icons/react";
import StreakBadge from "./StreakBadge";
import RewardsCard from "./RewardsCard";
import { api, appUserAuth } from "../lib/api";
import { STATUS_LABEL, BOOK_LABEL } from "../lib/progress";

const STEPS = [
  ["fit", "Complete Find My Fit", "/quiz"],
  ["calc", "Run the Tax-Free Calculator", "/calculator"],
  ["book", BOOK_LABEL, "/reserve"],
];
const ICON = { done: CheckCircle, in_progress: CircleHalf, not_started: Circle };

export default function RetentionHome() {
  const [p, setP] = useState(null);
  useEffect(() => {
    if (!appUserAuth.isLoggedIn()) return;
    api.get("/app/progress").then((r) => {
      const d = r.data;
      if (d.status.fit === "not_started" && localStorage.getItem("exodus_quiz_draft_v1")) d.status.fit = "in_progress";
      setP(d);
    }).catch(() => {});
  }, []);
  if (!p) return null;
  const first = (appUserAuth.fullName() || "").split(" ")[0];

  return (
    <section data-testid="retention-home" className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 pt-28 lg:pt-32 grid lg:grid-cols-12 gap-5">
      <div data-testid="continue-module" className="lg:col-span-5 border border-exodus-gold bg-exodus-elevated p-6 sm:p-8 relative rise">
        <div className="absolute top-0 left-0 w-16 h-1 bg-exodus-gold" />
        <p className="eyebrow">{first ? `Hi, ${first}` : "Continue"}</p>
        <h2 className="font-display text-3xl sm:text-4xl mt-3 leading-tight">Welcome back. Pick up where you left off.</h2>
        <Link data-testid="continue-next-action" to={p.next_action.href} className="btn-gold mt-8 w-full sm:w-auto justify-center">
          {p.next_action.key === "listen" && <Headphones size={18} weight="fill" />}{p.next_action.label} <ArrowRight size={16} weight="bold" />
        </Link>
      </div>

      <div data-testid="three-step-plan" className="lg:col-span-4 card-surface p-6 sm:p-8 rise rise-1">
        <p className="eyebrow mb-5">Your 3-step plan</p>
        <ol className="space-y-4">
          {STEPS.map(([k, label, href], i) => {
            const s = p.status[k];
            const Icon = ICON[s];
            return (
              <li key={k} data-testid={`plan-step-${k}`}>
                <Link to={href} className="flex items-center gap-4 group">
                  <Icon size={22} weight={s === "not_started" ? "regular" : "fill"} className={s === "done" ? "text-exodus-emerald" : "text-exodus-gold"} />
                  <span className="flex-1 text-sm group-hover:text-exodus-gold transition-colors">{i + 1}. {label}</span>
                  <span data-testid={`plan-step-${k}-status`} className={`text-[10px] eyebrow !tracking-[0.12em] ${s === "done" ? "!text-exodus-emerald" : s === "in_progress" ? "" : "!text-exodus-muted"}`}>{STATUS_LABEL[s]}</span>
                </Link>
              </li>
            );
          })}
        </ol>
      </div>

      <div data-testid="checkin-tile" className="lg:col-span-3 card-surface p-6 sm:p-8 flex flex-col rise rise-2">
        <p className="eyebrow">Every 2 days</p>
        <h3 className="font-display text-2xl mt-3">This Week's 4-Minute Check-In</h3>
        <p className="text-sm text-exodus-muted mt-2 flex-1">One question. One audio. One next step.</p>
        <Link data-testid="checkin-start" to="/check-in" className={`${p.checkin_done ? "btn-ghost" : "btn-gold"} mt-6 justify-center`}>
          {p.checkin_done ? "Check-in done — review" : "Start check-in"}
        </Link>
        <StreakBadge streak={p.streak} className="mt-5" />
      </div>
      {(p.streak.current > 0 || p.rewards.playbook_unlocked || p.rewards.free_booking_unlocked) && (
        <RewardsCard rewards={p.rewards} streak={p.streak} className="lg:col-span-12" />
      )}
    </section>
  );
}
